<p-toast position="bottom-right"></p-toast>
<p-toast key="log" position="center"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-crud-table #crudTable [crudService]="crudService"
                [transPartKey]="transPartKey" [fieldId]="'id'" [fieldName]="'code'" [fieldEnabled]="'enabled'"
                [tableConfig]="tableConfig" [newRecord]="newRecord"
                [(formRecord)]="formRecord" [formConfig]="formConfig"
                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                [formLoading]="formLoading"
                [(records)]="records"
                (dialogFormVisibleChange)="$event?onFormShow():{}"
                [defaultSortField]="'creationDate'" [defaultSortOrder]="-1"
                [writeRoles]="writeRoles" [totalRecords]="totalRecords"
                [(tableCurrentRequest)]="tableCurrentRequest" (tableCurrentRequestChange)="onTableCurrentRequestChange($event)"
                [prepareForClone]="prepareRecordForClone"
                [prepareForCreate]="prepareRecordForCreate"
                [prepareForEdit]="prepareRecordForEdit"
                [autoReloadTimeOut]="autoReloadTimeOut"
                dialogClass="list-e-ticket-dialog"
>
  <app-clearing-selection-summary dialog-footer-left [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                  [showLoadingSpinner]="true"></app-clearing-selection-summary>
</app-crud-table>
